import {useSnackbar as useSnackbarNotistack} from "notistack";

export default function useSnackbar() {

    const {closeSnackbar, enqueueSnackbar} = useSnackbarNotistack();

    function enqueueDefaultSnackbar(message, options) {
        return doSnackbar(message, options, 'default')
    }

    function enqueueInfoSnackbar(message, options) {
        return doSnackbar(message, options, 'info')
    }

    function enqueueSuccessSnackbar(message, options) {
        return doSnackbar(message, options, 'success')
    }

    function enqueueWarningSnackbar(message, options) {
        return doSnackbar(message, options, 'warning')
    }

    function enqueueErrorSnackbar(message, options) {
        return doSnackbar(message, options, 'error')
    }

    function doSnackbar(message, options, variant) {
        const key = enqueueSnackbar(message, {variant, onClick: () => closeSnackbar(key), ...options})
        return key;
    }

    return {enqueueSnackbar: enqueueDefaultSnackbar, enqueueInfoSnackbar, enqueueSuccessSnackbar, enqueueWarningSnackbar, enqueueErrorSnackbar}
}